'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError(err, definedAt) {
  this.Yu = null;
  this.aYk = null;
  this.Yu = err;
  this.aYk = definedAt;
}
export { $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError as $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError };
$p = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError() {
}
export { $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError as $h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError };
$h_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError)) {
    var x = this.Yu;
    var x$2 = x$0.Yu;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "OnGoogleSignInError";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yu;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "err";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.VM = (function() {
  return this.aYk;
});
function $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kC)));
}
export { $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError as $isArrayOf_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError };
var $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError, "app.webclient_prelude.components.AppMainModal$OnGoogleSignInError", ({
  kC: 1,
  d9: 1,
  cU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError as $d_Lapp_webclient\uff3fprelude_components_AppMainModal$OnGoogleSignInError };
//# sourceMappingURL=app.webclient_prelude.components.-App-Main-Modal$-On-Google-Sign-In-Error.js.map
